import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import AppContext from "./../context/AppContext";
import "react-toastify/dist/ReactToastify.css";
import ApiService from "../api/ApiService";
import "../css/app.css";
import { useNavigate } from "react-router-dom";
import Select from "react-select";


export default function BSLSRegistrationForm() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { user } = useContext(AppContext);
    const [templeList, setTempleList] = useState([]);
    const [searchTemple, setSearchTemple] = useState("");


    const [formData, setFormData] = useState({
        name: "",
        designation: "",
        phone: "",
        email: "",
    });
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const customSelectStyles = {
        control: (provided) => ({
            ...provided,
            width: "100%",
            maxWidth: "400px",
            padding: "2px", // add spacing similar to input
            fontSize: "18px",
            fontWeight: "500",
            color: "#000",
            border: "2px solid #343a40",
            borderRadius: "6px",
            boxSizing: "border-box",
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#000",
        }),
    };

    const fetchTempleList = async () => {
        try {
            const res = await ApiService.fetchTemplesOnlyListWithIskcon();
            console.log("added", res);

            setTempleList(res); // Store temple list in state
        } catch (error) {
            console.log("Error fetching temple list:", error);
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.designation || !formData.phone || !formData.email) {
            toast.error("Please fill all required fields");
            return;
        }

        try {
            const response = await ApiService.bslsRegistrationSubmit(formData);
            console.log("API Response:", response);

            console.log("Form data submitted:", formData);
            setIsSubmitted(true);
        } catch (error) {
            console.error("Error:", error);

            if (error.response && error.response.status === 400) {
                toast.error("Bad Request: " + error.response.data.message);
            } else {
                toast.error("An unexpected error occurred");
            }
        }
    };

    useEffect(() => {
        fetchTempleList();

    }, []);
    const filteredTemples = templeList
        .filter(
            (temple) =>
                temple.templeName &&
                temple.templeName
                    .toLowerCase()
                    .includes((searchTemple || "").toLowerCase())
        )
        .sort((a, b) => a.templeName.localeCompare(b.templeName));

    return (
        <>
            <ToastContainer />

            {isSubmitted ? (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        minHeight: "100vh",
                        flexDirection: "column",
                        textAlign: "center",
                        padding: "20px",
                    }}
                >
                    <h3>{t("Thank you for registering for BSLS.")}</h3>
                    <p style={{ maxWidth: "600px", marginTop: "10px" }}>
                        {t(
                            "You will receive a confirmation of your registration on email and our team will reach out to you with further details."
                        )}
                    </p>
                </div>
            ) : (
                <div className="log-in-container log-in-container-bsls" style={{ position: "relative" }}>
                    <div className="row login-white-background-bsls">
                        <div className="col-lg-6 login-image-right_bslspage"></div>
                        <div className="col-lg-6 d-flex justify-content-center align-items-center login-card">
                            <div className="login-div">
                                <form
                                    onSubmit={handleSubmit}
                                    className="mt-4 edit-profile-wrapper login-form-bsls"
                                >
                                    <h4
                                        className="login-welcome-text"
                                        style={{
                                            fontSize: "34px",
                                            textAlign: "center",
                                            marginTop: "-80px",
                                        }}
                                    >
                                        <svg
                                            width="50"
                                            height="50"
                                            viewBox="0 0 153 131"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            {/* SVG path code */}
                                        </svg>
                                        &nbsp;
                                        <p className="login-welcome-text-bsls" style={{ fontSize: "24px" }}>
                                            Bharat Sankirtan Leaders Sanga
                                        </p>
                                        <h4 className="login-welcome-sub-text">
                                        Register for the 2nd Annual Bharat Sankirtan Leaders Sanga, an initiative of the ICC Book Distribution Committee. This is a meeting of all the book distribution leaders of ISKCON India.
                                        </h4>
                                        <div className="text-center" style={{ margin: "20px 0" }}>
                                            <p style={{ fontSize: "16px", color: "#333", margin: "0", padding: "0 10px", lineHeight: "1.5" }}>
                                                <strong>Date:</strong> 8th-9th October 2026<br />
                                                <strong>Venue:</strong> ISKCON Pandharpur, Maharashtra
                                            </p>
                                        </div>
                                    </h4>
                                    <div className="row" style={{ fontSize: "16px", color: "#333", margin: "0", padding: "0 20px", lineHeight: "1.5", justifyContent: "center" }}>
                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="name" className="label-text mb-1">{t("Name of participant")}</label>
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                placeholder={t("Enter your full name")}
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                                style={{
                                                    width: "100%",
                                                    maxWidth: "400px",
                                                    padding: "12px 16px",
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    color: "#000",
                                                    border: "2px solid #343a40",
                                                    borderRadius: "6px",
                                                    boxSizing: "border-box"
                                                }}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="phone" className="label-text mb-1">{t("Phone number")}</label>
                                            <input
                                                type="tel"
                                                id="phone"
                                                name="phone"
                                                placeholder={t("Enter your phone number")}
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                style={{
                                                    width: "100%",
                                                    maxWidth: "400px",
                                                    padding: "12px 16px",
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    color: "#000",
                                                    border: "2px solid #343a40",
                                                    borderRadius: "6px",
                                                    boxSizing: "border-box"
                                                }}
                                            />
                                        </div>

                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="email" className="label-text mb-1">{t("Email ID")}</label>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                placeholder={t("Enter your email address")}
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                                style={{
                                                    width: "100%",
                                                    maxWidth: "400px",
                                                    padding: "12px 16px",
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    color: "#000",
                                                    border: "2px solid #343a40",
                                                    borderRadius: "6px",
                                                    boxSizing: "border-box"
                                                }}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="designation" className="label-text mb-1">{t("Designation")}</label>
                                            <input
                                                type="text"
                                                id="designation"
                                                name="designation"
                                                placeholder={t("Enter your designation")}
                                                value={formData.designation}
                                                onChange={handleChange}
                                                required
                                                style={{
                                                    width: "100%",
                                                    maxWidth: "400px",
                                                    padding: "12px 16px",
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    color: "#000",
                                                    border: "2px solid #343a40",
                                                    borderRadius: "6px",
                                                    boxSizing: "border-box"
                                                }}
                                            />
                                        </div>

                                        <div className="col-12 col-md-6 mb-3">
                                            <label htmlFor="nameoftemple" className="label-text mb-1">{t("Name Of Temple/Center")}</label>
                                            <Select
                                                id="nameoftemple"
                                                name="nameoftemple"
                                                options={[
                                                    ...filteredTemples.map((temple) => ({
                                                        value: temple.templeName,
                                                        label: temple.templeName,
                                                    })),
                                                    { value: "Other", label: t("Other") },
                                                ]}
                                                value={
                                                    formData.nameoftemple
                                                        ? { value: formData.nameoftemple, label: formData.nameoftemple }
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    setFormData({
                                                        ...formData,
                                                        nameoftemple: selectedOption ? selectedOption.value : "",
                                                    });
                                                }}
                                                placeholder={t("Select Temple")}
                                                isSearchable
                                                styles={customSelectStyles}
                                            />
                                            <p className="form-text text-muted">
                                                If your temple is not listed here, please select 'Other' and mention your temple name.
                                            </p>
                                        </div>
                                        {formData.nameoftemple === "Other" && (
                                            <div className="col-12 col-md-6 mb-3">
                                                <label htmlFor="othertemplename" className="label-text mb-1">{t("Other Temple Name")}</label>
                                                <input
                                                    type="text"
                                                    id="othertemplename"
                                                    name="othertemplename"
                                                    placeholder={t("Enter Other Temple Name")}
                                                    value={formData.othertemplename}
                                                    onChange={handleChange}

                                                    style={{
                                                        width: "100%",
                                                        maxWidth: "400px",
                                                        padding: "12px 16px",
                                                        fontSize: "16px",
                                                        fontWeight: "500",
                                                        color: "#000",
                                                        border: "2px solid #343a40",
                                                        borderRadius: "6px",
                                                        boxSizing: "border-box"
                                                    }}
                                                />
                                            </div>

                                        )}




                                    </div>


                                    <div className="col-12 text-center mt-4" style={{ fontSize: "16px", color: "#333", margin: "0", padding: "0 50px", lineHeight: "1.5" }}>
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-block login-button"
                                        >
                                            {t("Register")}
                                        </button>
                                    </div>
                                </form>

                                <div className="contact-info mt-4 text-center">
                                    <p className="mt-2">
                                        {t("For any queries related to registration, please contact us at:")}
                                        <br />
                                        <>
                                            Email: <a href="mailto:support@iccbrihadmridanga.com" style={{ color: 'black', textDecoration: 'none' }}>support@iccbrihadmridanga.com</a>
                                            <br />
                                            Phone: <a href="tel:+917387470108" style={{ color: 'black', textDecoration: 'none' }}>+91 7387470108</a>
                                        </>

                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
